import clsx from 'clsx';
import styles from './Button.module.scss';

export type ButtonVariant = 'project' | 'download' | 'generic' | 'big' | 'logo' | 'modal';
export type ButtonTone = 'dark' | 'ghostWhite' | 'black' | 'white' | 'borderBlack' | 'primary';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  tone?: ButtonTone;
  rounded?: boolean;
  small?: boolean;
  blackSvg?: boolean;
  logo?: React.ReactNode;
};

export default function Button({
  variant = 'project',
  tone,
  rounded,
  small,
  blackSvg,
  logo,
  className,
  children,
  ...props
}: ButtonProps)
{
  const variantClass = {
    project: styles.projectButton,
    download: styles.downloadButton,
    generic: styles.genericButton,
    big: styles.bigButton,
    logo: styles.logoButton,
    modal: styles.modalButton,
  }[variant];

  const toneClasses: Record<ButtonVariant, Partial<Record<ButtonTone, string>>> = {
    project: { dark: styles.projectButtonDark },
    download: { ghostWhite: styles.downloadButtonGhostWhite },
    generic: {
      black: styles.genericButtonBlack,
      white: styles.genericButtonWhite,
      borderBlack: styles.genericButtonBorderBlack,
    },
    big: { black: styles.bigButtonBlack },
    logo: {},
    modal: { primary: styles.modalButtonPrimary },
  };
  const toneClass = tone ? toneClasses[variant][tone] : undefined;

  return (
    <button
      className={ clsx(
        variantClass,
        tone && toneClass,
        rounded && (variant === 'logo' ? styles.logoButtonRounded : styles.projectButtonRounded),
        small && styles.projectButtonSmall,
        blackSvg && styles.logoButtonBlackSvg,
        className,
      ) }
      { ...props }
    >
      { logo && <span className={ styles.logo }>{ logo }</span> }
      { children }
    </button>
  );
}
